import React from "react";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import { IState } from "./Data";
import { CommonSubmitButton, LoaderType, RenderForm, showNotification, SwitchLoader } from "../../common";
import { EmailTemplateModel } from "../../model";
import { EmailTemplateService } from "../../services/EmailTemplateService";
import Lang from "../../common/lang/Lang";
import Swal from "sweetalert2";

export const EmailTemplateForm = (props: IState) => {
  let history = useHistory();
  const [form, setForm] = React.useState({} as EmailTemplateModel);
  const [formData, setFormData] = React.useState({
    keywords: {},
  }) as any ;

  React.useEffect(() => {
    async function init() {
      const concepts = await EmailTemplateService.formData();
      setFormData(concepts);     
    }
    init();
    
  }, [])
  const selectionRef = React.useRef<Range | null>(null);

  React.useEffect(() => {
    const editableDiv = document.querySelector(".note-editable");
    if (!editableDiv) return;
    const saveSelection = () => {
      const sel = window.getSelection();
      if (sel && sel.rangeCount > 0) {
        selectionRef.current = sel.getRangeAt(0);
      }
    };
    const events: (keyof HTMLElementEventMap)[] = ["focus","click","keyup","mouseup"];
    events.forEach((e) => editableDiv.addEventListener(e, saveSelection));
    return () => {
      events.forEach((e) => editableDiv.removeEventListener(e, saveSelection));
    };
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLElement>) => {
    const target = event.target as HTMLInputElement;
    const { name, value, checked } = target;
    if (name === "type") {
      if ( form.type && form.type.trim() !== "" &&  form.content && form.content.trim() !== "" ) {
        Swal.fire({
          title: "Are you sure?",
          text: Lang.change_template_type_confirm,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.value) {
            setForm((prevForm) => ({
              ...prevForm,
              type: value,
              content: "",
              keywords: [],
            }));
            setTimeout(() => {
              const editor = document.querySelector(".note-editable");
              if (editor) editor.innerHTML = "";
            }, 0);
          }
        });
        return;
      }
    }
    if (name === "keywords") {
      let updatedKeywords = form.keywords || [];
      const regex = new RegExp(`{{${value}}}`, "g");
      const editor = document.querySelector(".note-editable") as HTMLElement | null;
      if (!editor) return;
      if (checked) {
        if (!updatedKeywords.includes(value)) updatedKeywords.push(value);
        if (!editor.innerText.includes(`{{${value}}}`)) {
          insertTagAtCursor(value);
        }
      } else {
        removeKeywordFromEditor(editor, regex);
        updatedKeywords = updatedKeywords.filter((k) => k !== value);
      }
      setForm({ ...form, keywords: updatedKeywords, content: editor.innerHTML });
      return;
    }
    setForm({ ...form, [name]: value });
  };

  const removeKeywordFromEditor = (element: HTMLElement, regex: RegExp) => {
    element.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.nodeValue = node.nodeValue?.replace(regex, "");
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        removeKeywordFromEditor(node as HTMLElement, regex);
      }
    });
  };

  
  const insertTagAtCursor = (tag: string) => {
    const editor = document.querySelector(".note-editable") as HTMLElement;
    if (!editor) return;
    let range = selectionRef.current;
    if (!range) {
      range = document.createRange();
      range.selectNodeContents(editor);
     if (editor.innerText.trim() !== "") {
       range.collapse(false);
      } else {
        range.collapse(true);
      }

      selectionRef.current = range;
    }
    const node = document.createTextNode(`{{${tag}}}`);
    range.insertNode(node);
    range.setStartAfter(node);
    range.setEndAfter(node);
    const sel = window.getSelection();
    if (sel) {
      sel.removeAllRanges();
      sel.addRange(range);
    }
    selectionRef.current = range;
  };


  const handleEditorChange = (message: string) => {
    const possibleKeywords = formData.keywords?.[form.type] || [];
    const detectedKeywords = possibleKeywords.map(k => k.keyword).filter(k => {
      const regex = new RegExp(`\\{\\{\\s*${k}\\s*\\}\\}`, "g");
      return regex.test(message);
    });
    setForm({ ...form, content: message, keywords: detectedKeywords });
  };


  React.useEffect(() => {
    setForm(props.template)
  },[props.template])


    const FormInputs = [
      {
        "name" : "name",
        "value" : _.get(form, "name", ""),
        "onChange": handleChange,
        "required": true,
        "placeholder": "Enter name",
        "label": "Name",
         "parent_class": 'col-md-12 col-lg-12'
      },      
      
      {
        "name" : "subject",
        "value" : _.get(form, "subject", ""),
        "onChange": handleChange,
        "required": true,
        "placeholder": "Enter subject",
        "label": "Subject",
         "parent_class": 'col-md-12 col-lg-12'
      },
      {
        "name" : "content",
        "value" : _.get(form, "content", ""),
        "onEditorChange": handleEditorChange,
        "required": true,
        "placeholder": "Enter content",
        "type": "editor",
        "label": "Content",
        "parent_class": 'col-md-12 col-lg-12'
      },
    ];

    function isDisable() {
      const fields = FormInputs.reduce((acc, val) => acc ? acc : val.value === "" && val.required, false);
      return fields;
    }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    SwitchLoader(LoaderType.BUTTON);

    if(props.id){
      EmailTemplateService.update(form, props.id).then((message) => {
        showNotification("success", message);
        history.push(`/settings/email-templates`)
      }).catch(() => {});
    } else {
      EmailTemplateService.store(form).then((message) => {
        showNotification("success", message);
        history.push(`/settings/email-templates`)
      }).catch(() => {});
    }
  }

  return(
      <form className="kt-form" id={'customer_form'} onSubmit={handleSubmit}>
        <div className="col-md-8" style={{float:'left', border: "1px solid #ebedf2"}}>          
          <div className={'row'}>
            <RenderForm items={FormInputs}/>
          </div>
          <CommonSubmitButton disabled={isDisable()}/>
        </div>
        <div className="col-md-4" style={{float:'right', border: "1px solid #ebedf2"}}>
          <div className={'row'}>
            <div className="col-md-12 col-lg-12">
              <div className="form-group">
                <label>Template Type </label>
                <select className="form-control" name="type" onChange={handleChange} value={form.type || ""} disabled={form.is_default == 1}>
                  <option value="">Choose Type</option>
                  {Object.keys(formData.keywords).map((keyword: any, index: number) => {
                    return <option key={index}  value={keyword}>{keyword}</option>
                  })}
                </select>
              </div>
              <div className="form-group">                
                {
                  formData.keywords[form.type] && formData.keywords[form.type].map((keyword: any, index: number) => {
                    return (
                      <label className="kt-checkbox kt-checkbox--brand" key={`keyword-${index}`}>
                        <input key={index} type="checkbox" checked={form?.keywords?.indexOf(keyword.keyword) > -1} value={keyword.keyword} name="keywords" className="form-control" onChange={handleChange}/>
                        {keyword.keyword}
                        <span></span>
                      </label>
                    )                                      
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </form>
    )
}
